import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConfiguratorComponent } from '../Forms/types';
import { Select, MenuItem } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { useStyles } from './styles';
import { selectOptionSync, setCustomData } from '../../Reducers/Configurator/Actions';
import { getDisabledOptions } from '../../Reducers/App/Selectors';
import OptionComment from './OptionComment';
import { getAttributeValueFor } from './utils';

interface ComponentItemProps {
  component: ConfiguratorComponent;
}

const ComponentItem: React.FC<ComponentItemProps> = (props) => {
  const { component } = props;
  const [value, setValue] = useState(component.selectedOption ? component.selectedOption.identifier : '');
  const classes = useStyles();
  const dispatch = useDispatch();
  const disabledOptions = useSelector(getDisabledOptions);

  const handleChange = (option) => {
    setValue(option.identifier);
    dispatch(setCustomData({ [component.identifier]: option.identifier }));
    dispatch(selectOptionSync({ ...option, amount: option.amount ? 0 : 1 }, component));
  };

  const selectedOptionIdentifier = component.selectedOption?.identifier;
  useEffect(() => {
    if (selectedOptionIdentifier !== value) {
      setValue(selectedOptionIdentifier);
    }
  }, [selectedOptionIdentifier, setValue]);

  return (
    <>
      {component.options.length === 2 && !getAttributeValueFor(component, 'as_dropdown') ? (
        <>
          <ToggleButtonGroup className={classes.buttonGroup} value={value}>
            {component.options.map((option) => (
              <ToggleButton
                key={option.identifier}
                value={option.identifier}
                onClick={() => handleChange(option)}
                disabled={component.active === false || disabledOptions.includes(option.identifier)}
              >
                {t(option.title)}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          <OptionComment component={component} variant="configuration" />
        </>
      ) : (
        <>
          <Select
            displayEmpty
            disabled={component.active === false}
            value={value || ''}
            className={classes.select}
            onChange={(evt) => {
              handleChange(component.options.find(({ identifier }) => identifier === evt.target.value));
            }}
            disableUnderline
            renderValue={(selected: string) => {
              if (selected.length === 0) {
                return 'Please choose';
              }
              return component.options.find(({ identifier }) => identifier === selected)?.title;
            }}
          >
            {component.options.map((option) => (
              <MenuItem
                key={option.identifier}
                value={option.identifier}
                disabled={component.active === false || disabledOptions.includes(option.identifier)}
              >
                {option.title}
              </MenuItem>
            ))}
          </Select>
          <OptionComment component={component} variant="configuration" />
        </>
      )}
    </>
  );
};

export default ComponentItem;
